import { useEffect } from "react";
import axios from "axios";
import Hero from "@/components/Hero";
import StatsBand from "@/components/StatsBand";
import WhereWeSell from "@/components/WhereWeSell";
import HighEndAutographs from "@/components/HighEndAutographs";
import Collections from "@/components/Collections";
import Marquee from "@/components/Marquee";
import ShowReminders from "@/components/ShowReminders";
import ConsignTeaser from "@/components/ConsignTeaser";
import { SHOP_ENABLED } from "@/lib/config";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Home() {
  useEffect(() => {
    axios.get(`${API}/`).catch(() => {});
  }, []);

  return (
    <main className="bg-[#050505] text-white overflow-x-hidden">
      <Hero />
      <StatsBand />
      <WhereWeSell />
      {SHOP_ENABLED && <HighEndAutographs />}
      <Collections />
      <Marquee />
      <ShowReminders />
      <ConsignTeaser />
    </main>
  );
}
